import './attendance.less';
import * as _ from 'lodash';

import { AttendanceCollection } from './AttendanceCollection';
import { Attendance } from '../../objects/Attendance';

/**
 * @typedef { import('./AttendanceModel').AttendanceModel } AttendanceModel
 */

angular.module("tromanWeb").controller('AttendanceController', ['$q', 'stateService', 'tromanServer', 'dialogService', 'systemInfo', 'meetingShared', function ($q, stateService, tromanServer, dialogService, systemInfo, meetingShared) {

    var isBusy = false;

    this.table = null;
    this.attendanceForm = null;
    this.toadd = null;
    this.hasButtons = false;
    this.showRequestAllTimeReports = false;
    this.canRequestAllTimeReports = false;

    this._updateButtons = function () {
        /** @type {AttendanceCollection}*/
        const ac = this.ac;
        if (ac != null) {
            this.hasButtons = ac.attendances.some(x => x.attendance.CeremonyId || x.hasTimeReport || x.canRequestTimeReport || x.canSpecifyMission());
            this.showRequestAllTimeReports = ac.attendances.some(x => x.canRequestTimeReport);
            this.canRequestAllTimeReports = ac.attendances.some(x => x.canRequestTimeReport && !x.isRequestingTimeReport);
        } else {
            this.hasButtons = false;
            this.canRequestAllTimeReports = false;
            this.showRequestAllTimeReports = false;
        }
    };

    this.personChanged = function personChanged() {
        var candidates = [];
        if (this.ac != null && this.toadd != null) {
            candidates = _.filter(this.toadd.Missions, x => x.MandatePeriod.OrganizationId === this.ac.meeting.OrganizationId);
        }
        this.addingMission = candidates.length === 1 ? candidates[0] : null;
    };

    this.add = function add() {
        if (this.addingMission == null) return;
        if (this.ac == null) return;

        this.ac.include(this.addingMission);
        this._updateButtons();
        this.toadd = null;
        this.attendanceForm.$setDirty();
    };

    this.addMembers = function addMembers(withsubs) {
        if (this.ac == null) return;

        if (this.ac.includeMembers(withsubs)) {
            this._updateButtons();
            this.attendanceForm.$setDirty();
        }
    };

    this.canAddMissionGroup = function canAddMissionGroup() {
        if (isBusy) return false;
        if (this.ac == null) return false;
        if (this.selectedMissionGroupId == null) return false;

        return true;
    };

    this.addMissionGroup = function addMissionGroup() {
        if (!this.canAddMissionGroup()) return;

        isBusy = true;

        return tromanServer.Missions
            .search({ MissionGroupId: this.selectedMissionGroupId })
            .then(result => {
                let missionIds = _.map(result, x => x.Id);
                if (this.ac.includeMissionIds(missionIds)) {
                    this._updateButtons();
                    this.attendanceForm.$setDirty();
                }
                this.selectedMissionGroupId = null;
            })
            .catch(dialogService.error)
            .finally(() => isBusy = false);
    };

    /**
     * @param {AttendanceModel} attendanceModel
     */
    this.setLegacyMission = function setLegacyMission(attendanceModel) {
        if (this.ac == null) return;

        var missions = this.ac.getAvailableMissions(attendanceModel);
        dialogService.setAttendanceMission(missions, attendanceModel.attendance)
            .catch(() => null) // dismissed
            .then(mission => {
                if (mission) {
                    this.ac.specifyMission(attendanceModel, mission);
                    this._updateButtons();
                }
            })
            .catch(dialogService.error);
    };

    this.removeSelected = function removeSelected() {
        if (this.ac == null) return;
        if (this.table == null) return;
        if (this.table.selectionCount === 0) return;

        /** @type {AttendanceModel[]} */
        let items = this.table.selectedItems();
        if (items.length === 0) return;

        let message = [items.length === 1 ? 'Ta bort 1 närvaropost' : `Ta bort ${items.length} närvaroposter`];

        let [withPayments, withoutPayments] = _.partition(items, x => x.attendance.HasPayments);

        if (withoutPayments.length === 0) {
            dialogService.error('Alla markerade närvaroposter har arvoden och kan inte tas bort.');
            return;
        }

        if (withPayments.length === 1) {
            message.push('1 närvaropost har arvoden och kan inte tas bort.');
        } else if (withPayments.length > 1) {
            message.push(withPayments.length + ' närvaroposter har arvoden och kan inte tas bort.');
        }

        let [withCeremony, withoutCeremony] = _.partition(withoutPayments, x => x.attendance.CeremonyId != null);
        if (withCeremony.length === 1) {
            message.push('1 närvaropost har rapporterats som förrättning, förättningen kommer finnas kvar och blir tillgänglig att knyta till ett annat möte.');
        } else if (withCeremony.length > 1) {
            message.push(withCeremony.length + ' närvaroposter har rapporterats som förrättning, förättningen kommer finnas kvar och blir tillgänglig att knyta till ett annat möte.');
        }

        let [withPolitikerInfo, _remaining] = _.partition(withoutCeremony, x => x.attendance.HasClaims || x.attendance.TimeReport != null);
        // TODO should the warning only happen when TimeReport.State === timeReportState.recalled
        if (withPolitikerInfo.length === 1) {
            message.push('1 närvaropost har registrerade anspråk/tidrapporter. Dessa kommer fortsatt visas i Troman Politiker, men kommer inte längre kunna behandlas i Troman.');
        } else if (withPolitikerInfo.length > 1) {
            message.push(withPolitikerInfo.length + ' närvaroposter har registrerade anspråk/tidrapporter. Dessa kommer fortsatt visas i Troman Politiker, men kommer inte längre kunna behandlas i Troman.');
        }

        if (message.length > 1) {
            message.push('Vill du ta bort närvaroposter?');
            dialogService.confirm(message).then(() => {
                this.ac.exclude(withoutPayments);
                this._updateButtons();
            });
        } else {
            this.ac.exclude(withoutPayments);
            this._updateButtons();
        }
    };

    this.canSave = function canSave() {
        if (this.ac == null) return false;
        if (isBusy) return false;

        return this.ac.isChanged && this.attendanceForm?.$valid;
    };

    this.save = function save() {
        if (!this.canSave()) return;

        isBusy = true;

        tromanServer.Payroll.updateMeetingPayroll(meetingShared.meeting.Id, this.ac.createUpdate())
            .then(() => {
                stateService.forceReload('meeting');
            })
            .catch(dialogService.error)
            .finally(() => { isBusy = false; });
    };

    this.createList = function createList() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createAttendanceModelList(list);
    };

    this.emailList = function emailList() {
        if (this.table == null) return;
        var list = this.table.selectedItems().map(x => x.getPerson());
        dialogService.createEmailList(list);
    };

    this.showCeremonyInfo = function (attendanceModel) {
        dialogService.showCeremony(attendanceModel.attendance.CeremonyId);
    };

    this.requestTimeReport = function(attendanceModel) {
        if (!attendanceModel.canRequestTimeReport) return;
        if (attendanceModel.isRequestingTimeReport) return;
        attendanceModel.isRequestingTimeReport = true;
        this._updateButtons();
    };

    this.undoRequestTimeReport = function(attendanceModel) {
        if (!attendanceModel.canRequestTimeReport) return;
        if (!attendanceModel.isRequestingTimeReport) return;
        attendanceModel.isRequestingTimeReport = false;
        this._updateButtons();
    };

    this.requestAllTimeReports = function() {
        if (!this.canRequestAllTimeReports) return;
        _.forEach(this.ac.attendances, x => {
            if (x.canRequestTimeReport && !x.isRequestingTimeReport) {
                x.isRequestingTimeReport = true;
            }
        });
        this._updateButtons();
    };

    /**
     * @param {AttendanceModel} attendanceModel
     */
    this.showTimeReportInfo = function (attendanceModel) {
        dialogService.showAttendanceTimeReport(attendanceModel.attendance, true).then(result => {
            let newAttendance = result?.newAttendance;
            if (newAttendance instanceof Attendance) {
                let replacement = attendanceModel.withAttendance(newAttendance);
                this.ac.replaceAttendance(attendanceModel, replacement);
                this._updateButtons();
            }
        });
    };

    this.isRemote = function (item) {
        var org = item.getOrganization();
        return (org == null) ? false : (org.Id !== this.meeting.OrganizationId);
    };

    this.$onInit = function () {
        let meeting = meetingShared.meeting;

        $q.all({
            attendanceList: tromanServer.Payroll.getAttendance(meeting.Id),
            missions: tromanServer.Missions.search({ Start: meeting.Date, End: meeting.Date, IsVacant: false }),
            missionGroups: tromanServer.MissionGroups.search({ HasMissions: true }),
        }).then(result => {
            this.ac = new AttendanceCollection(result.attendanceList, result.missions, result.missionGroups, systemInfo.IsPolitikerEnabled);
            this._updateButtons();
            stateService.guard(() => this.attendanceForm?.$dirty || this.ac.isChanged);
        }).catch(err => {
            this.error = err;
        });
    };
}]);
